// extracted by mini-css-extract-plugin
export var messageSideLeft = "_r2-1";
export var stateContainer = "_r2-0";